import { fetchRequest } from "./request";

// this will be called when the user clicks yes on the ConfirmDelete component
export const globalDeleteItem = async (url) => {
  return fetchRequest(url, null, "delete", false);
};
